import { ca } from '@cian/analytics';

import { CONCLUSION_TYPE_TO_ANALYTICS_LABEL_MAP } from '../../../constants/analytics';
import { EConclusion } from '../../../types/calculate';

export function trackMortgageRateClick(type: EConclusion) {
  const label = CONCLUSION_TYPE_TO_ANALYTICS_LABEL_MAP[type];

  ca('eventSite', {
    name: 'oldevent',
    action: 'click_mortgage',
    category: 'invest_calculator',
    label,
  });
}
